import React from 'react'
import DropdownItem from './DropdownItem'

export const getDropdownItems = countriesData =>
  countriesData.map(countryData => ({
    component: <DropdownItem data={countryData} />,
    label: countryData.name,
    value: countryData.iso
  }))
